module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Inter-SemiBold-af031ccbfc3d90928feba54c9a4b2d4d.woff";